import React, { Component } from 'react'
import { Button } from 'src/components/button/Button';
import "./ResourceCard.scss";

export default class ResourceCard extends Component {
  render() {
    const {color, title, button, link, width } = this.props;
    let buttonIcon = null;
    if (button) {
      switch (button.type) {
        case 'email':
            buttonIcon = './assets/email-icon.svg';
            break;

        case 'download':
        default:
          buttonIcon = './assets/download-icon.svg';
          break;
      }
    }
    return (
      <div className="ResourceCard" style={{ width }}>
        <div className="ResourceCard-title">{title}</div>
        {/* <div className="ResourceCard-content">Check all the steps there are only like 4, you'll be fine.</div> */}
        {button ? <Button icon={buttonIcon} color={color} href={button.url} target="_blank" analytics={button.analytics}>{button.label}</Button> : null }
        {/* <div className="ResourceCard-content">Check all the steps there are only like 4, you'll be fine.</div> */}
        {link ? <Button icon="./assets/link-icon.svg" transparent color={color} href={link.url} target="_blank" analytics={link.analytics}>{link.label}</Button> : null }
      </div>
    )
  }
}
